import React from "react";
import { RouteComponentProps } from "react-router";
import {
  CONTRACT_PRICE_TEMPLATE_SLIDER,
  ContractsPriceTemplateEditLocation
} from "@navigation";
import { store } from "@store";
import { checkIfDirectRoute } from "@utils/navigationUtils";
import { ContractsPriceTemplatesSearch } from "@config_editor/ContractsPriceTemplates/Search/ContractsPriceTemplatesSearch";

type Props = RouteComponentProps<any>;

export function ContractsPriceTemplateSearchPage(props: Props) {
  const { match } = props;
  const { url } = match;
  const { navigation } = store();

  const searchProps = {
    onItemOpen: (id: string) =>
      navigation.open(
        CONTRACT_PRICE_TEMPLATE_SLIDER,
        new ContractsPriceTemplateEditLocation(id)
      ),
    onNewItem: () => {
      navigation.open(
        CONTRACT_PRICE_TEMPLATE_SLIDER,
        new ContractsPriceTemplateEditLocation("new")
      );
    }
  };

  return (
    <>
      {catchDirectUrl(url)}
      <ContractsPriceTemplatesSearch {...searchProps} />
    </>
  );
}

function catchDirectUrl(url) {
  return checkIfDirectRoute(
    `${url}/:templateId/:action1?`,
    CONTRACT_PRICE_TEMPLATE_SLIDER,
    ({ action1, templateId }) => {
      const action = action1 || "view";
      const realId = templateId !== "new" ? templateId : null;
      if (templateId === "new" || (templateId && action === "edit")) {
        return new ContractsPriceTemplateEditLocation(realId);
      }
    }
  );
}
